import { ReadOnlyField } from '@warehouse/shared/legacy-ui';
import styled from 'styled-components';

export const ReadOnlyIdField = styled(ReadOnlyField)`
	font-family: monospace;
	user-select: all;
`;
